import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const smartHomeUrl = environment.smartHomeUrl;

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  private apiUrl: string;
  private httpDirecto: HttpClient;

  constructor(
    private _http: HttpClient,
    private httpBackend: HttpBackend
  ) { 
    this.apiUrl = `${smartHomeUrl}api/`;
    this.httpDirecto = new HttpClient(this.httpBackend);
  }

  listarUsuarios(): Observable<any> {

    let url =  `${this.apiUrl}usuarios`;

    return this._http.get(url, { });

  }

  guardarUsuarios(data): Observable<any> {

    let myData = { 
      "name": data.name,
      "last_name": data.lastName,
      "number_document": data.numberDocument,
      "indicative": data.indicative,
      "phone": data.phone
    }

    let url = `${this.apiUrl}usuarios`;
   
    return this._http.post(url, myData);

  }

  eliminarUsuarios( idUsuario ) {
      let url = `${this.apiUrl}usuarios/usuario/${idUsuario}`;
    
      return this._http.delete(url, {});     
  }

  descargarFormatoExcel(companyId: number): Observable<Blob> {
    let url = `${this.apiUrl}masive/download-template/${companyId}`;
    return this._http.get(url, { responseType: 'blob' });
  }

  subirArchivoMasivo(file: File): Observable<any> {
    let url = `${this.apiUrl}masive/upload`;
    let formData = new FormData();
    formData.append('file', file);
    return this._http.post(url, formData);
  }

  listarUsuariosMasivos(companyId: number): Observable<any> {
    let url = `${this.apiUrl}masive/email-status/${companyId}`;
    return this._http.get(url);
  }

  reenviarCorreo(usId: number, urId: number, visitante?: any): Observable<any> {
    let url = `${this.apiUrl}masive/resend-email`;
    let body: any = {
      us_id: usId,
      ur_id: urId
    };
    if (visitante) {
      body.visitante = visitante;
      body.name = visitante.name;
      body.first_name = visitante.first_name;
      body.last_name = visitante.last_name;
      body.email = visitante.email;
      body.phone = visitante.phone;
      body.indicative = visitante.indicative;
      body.type_document = visitante.type_document;
      body.number_document = visitante.number_document;
      body.us_nombres = visitante.us_nombres;
      body.us_apellidos = visitante.us_apellidos;
      body.us_correo = visitante.us_correo;
      body.us_celular = visitante.us_celular;
      body.us_numero_documento = visitante.us_numero_documento;
    }
    return this._http.post(url, body);
  }

  editarTitular(datos: {
    id: number;
    name: string;
    last_name: string;
    type_document: string;
    number_document: string;
    indicative: string;
    phone: string;
  }): Observable<any> {
    const url = `${this.apiUrl}lugares/titular/edit`;
    const headers = new HttpHeaders({
      'cli': 'PAdmon'
    });
    return this.httpDirecto.patch(url, datos, { headers });
  }
}
